import React from 'react';
import PropTypes from 'prop-types';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../lang/main';
import ProductGridPrice from './ProductGridPrice';

function ProductListItem(props) {
    const { item, showNLISFilter, showNAITFilter } = props;
    const {
        ID,
        InternalItemID,
        FamilyTitle,
        Title,
        IsSale,
        IsNLIS,
        IsBuyable,
        ReSizedProductListingImage,
        Link,
        ProdType,
        OfficialType,
    } = item;
    const image =
        ReSizedProductListingImage ||
        (typeof window.defaultImages.productList != 'undefined'
            ? window.defaultImages.productList
            : 'https://via.placeholder.com/500');

    const linkTitle =
        ProdType === 'ID'
            ? getTranslation('PRODUCT_LIST_ITEM_LINK_TITLE_ID')
            : Title;

    return (
        <div className='product-grid__item' key={ID}>
            <a href={Link} className='product-grid__link' title={linkTitle}>
                <figure className='photo product-grid__photo'>
                    <img src={image} className='photo__image' />
                </figure>
                <div className='product-grid__content'>
                    <span className='product-grid__heading'>
                        {InternalItemID}
                    </span>
                    <span className='product-grid__title'>
                        {FamilyTitle || Title}
                    </span>
                    {/*<span className="product-grid__extra">50 cols/styles available</span>*/}
                </div>
                <div className='product-grid__label-wrapper'>
                    {window.loggedIn && IsSale === true && (
                        <span className='product__label product__label--red'>
                            <LocalizedMessage id={'ON_SALE'} />
                        </span>
                    )}
                    {(IsNLIS === true && OfficialType === 'NLIS') && (
                        <span className='product__label product__label--nlis'>
                            <LocalizedMessage id={'NLIS'} />
                        </span>
                    )}
                    {(IsNLIS === true && OfficialType === 'NAIT') && (
                        <span className='product__label product__label--nlis'>
                            <LocalizedMessage id={'NAIT'} />
                        </span>
                    )}                    
                </div>
                <div className='product-grid__price-wrapper'>
                    <ProductGridPrice {...props} />
                </div>
                {IsBuyable === true && (
                    <div className='product-grid__action-wrapper'>
                        <div className='button'>
                            <span>
                                <LocalizedMessage id={'BUY_NOW'} />
                            </span>
                        </div>
                    </div>
                )}
            </a>
        </div>
    );
}
// default props
ProductListItem.defaultProps = {
    item: {},
    showNLISFilter: true,
    showNAITFilter: true,
};
// validate props
ProductListItem.propTypes = {
    item: PropTypes.any.isRequired,
    showNLISFilter: PropTypes.bool,
    showNAITFilter: PropTypes.bool,
};

export default ProductListItem;
